import N8nLoading from './Loading.vue';

export default N8nLoading;
